export default __webpack_public_path__ + "static/media/irbis_white_b.196b6f32.png";